import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import Multiselect from 'multiselect-react-dropdown'
import moment from 'moment'
import { isEmpty } from 'lodash'
import DateTimePicker from 'react-datetime-picker'
import { CustomDescriptionBox } from '../../../components'
import { AppContext } from 'src/views/context/app'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'

const SubscriptionCreateModal = (props) => {
  const {
    countries,
    currencies,
    createCallback,
    updateCallback,
    data,
    openModal,
    handleClose,
    entity,
  } = props
  const { accountObj } = useContext(AppContext)
  const [subscriptionName, setSubscriptionName] = useState('')
  const [description, setDescription] = useState('')
  const [price, setPrice] = useState(0)
  const [currency, setCurrency] = useState('')
  const [duration, setDuration] = useState(0)
  const [geoBlockCountries, setGeoBlockCountries] = useState([])
  const [planStatus, setPlanStatus] = useState(false)
  const [geoBlocking, setGeoBlocking] = useState(false)
  const [errorData, setErrorData] = useState({})
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState('')

  let isGeoBlockAllowed = accountObj?.od_resource_allowances?.geo_block

  const editFlag = !isEmpty(data)

  const handleEdit = () => {
    if (!isEmpty(data)) {
      setPlanStatus(data.status)
      setSubscriptionName(data.name)
      setDescription(data.description)
      setPrice(data.amount)
      setCurrency(data.currency)
      setDuration(data.duration)
      setStartDate(data.start_date ? new Date(data.start_date) : '')
      setEndDate(data.end_date ? new Date(data.end_date) : '')
      setGeoBlocking(data.geo_block_enabled)
      setGeoBlockCountries(data.geo_block_metadata)
    }
  }

  useEffect(() => {
    handleEdit()
  }, [data])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      subscriptionName: '',
      price: '',
      duration: '',
      geoblock: '',
      startDate: '',
      endDate: '',
    }

    if (subscriptionName.trim().length === 0) {
      isFormValid = false
      temp.subscriptionName = 'Name Cannot be Empty!'
    }
    if (isNaN(price) || currency.trim().length === 0) {
      isFormValid = false
      temp.price = 'Invalid values!'
    }
    if (duration === 0) {
      isFormValid = false
      temp.duration = 'Select Duration!'
    }
    if (duration > 2000) {
      isFormValid = false
      temp.duration = 'Please enter Duration Below 2000!'
    }
    if (!startDate) {
      isFormValid = false
      temp.startDate = 'Select Start Date!'
    }
    if (!endDate) {
      isFormValid = false
      temp.endDate = 'Select End Date!'
    }
    if (geoBlocking && geoBlockCountries.length === 0) {
      isFormValid = false
      temp.geoblock = 'Select Countries!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleGeoBlocking = (event) => {
    const { checked } = event.target
    handleClearError('geoblock')
    if (!checked) {
      setGeoBlockCountries([])
    }
    setGeoBlocking(checked)
  }

  const handleCreate = () => {
    if (validateInfo()) {
      let payload = {
        name: subscriptionName,
        description: description,
        currency: currency,
        amount: price,
        duration: duration,
        start_date: moment(startDate).format('yyyy-MM-DD'),
        end_date: moment(endDate).format('yyyy-MM-DD'),
        geo_block_enabled: geoBlocking,
        status: editFlag ? planStatus : true,
        geo_block_metadata: geoBlocking ? geoBlockCountries : [],
        type: entity === 'Subscription' ? 'normal' : 'ppv',
      }
      editFlag ? updateCallback(payload, data._id) : createCallback(payload)
    }
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      errorData[field] = ''
    }
  }

  const handleDateChange = (err, value, func) => {
    let temp = errorData
    temp[`${err}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  return (
    <CModal size="lg" alignment="center" visible={openModal}>
      <CModalHeader>
        <CModalTitle>
          {editFlag ? 'Edit ' : 'Create '}
          {entity} Plan
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <div className="mb-3">
            <CFormLabel>{entity} Name*</CFormLabel>
            <CFormInput
              type="text"
              value={subscriptionName}
              onChange={(e) => {
                setSubscriptionName(e.target.value)
                handleClearError('subscriptionName')
              }}
            />
            <div className="message-text error-message">
              <p>{errorData.subscriptionName}</p>
            </div>
          </div>
          <div className="mb-3">
            <CustomDescriptionBox
              title="Description"
              rows={2}
              value={description}
              onChange={setDescription}
              limit={500}
            />
          </div>
          <CRow className="mb-3">
            <CCol lg={6}>
              <CFormLabel>Price*</CFormLabel>
              <CRow>
                <CCol lg="6">
                  <CFormInput
                    type="number"
                    min="0"
                    value={price}
                    onChange={(e) => {
                      handleClearError('price')
                      setPrice(parseFloat(e.target.value))
                    }}
                  />
                </CCol>
                <CCol lg="6">
                  <CFormSelect
                    value={currency}
                    onChange={(e) => {
                      handleClearError('price')
                      setCurrency(e.target.value)
                    }}
                  >
                    <option value="" disabled />
                    {!isEmpty(currencies)
                      ? currencies.map((info, index) => (
                          <option key={index} value={info}>
                            {info}
                          </option>
                        ))
                      : null}
                  </CFormSelect>
                </CCol>
                <div className="message-text error-message">
                  <p>{errorData.price}</p>
                </div>
              </CRow>
            </CCol>
            <CCol lg={6}>
              <CFormLabel>Duration* (in days specifying the validity)</CFormLabel>
              <CFormInput
                type="number"
                min="0"
                value={duration}
                onChange={(e) => {
                  handleClearError('duration')
                  setDuration(parseFloat(e.target.value))
                }}
              />
              <div className="message-text error-message">
                <p>{errorData.duration}</p>
              </div>
            </CCol>
          </CRow>
          <div className="mt-4 mb-4 d-flex justify-content-between">
            <div style={{ width: '39%' }}>
              <CFormLabel>Applicable From*</CFormLabel>
              <CCol>
                <DateTimePicker
                  className="shadow-effect w-100"
                  onChange={(value) => handleDateChange('startDate', value, setStartDate)}
                  name="startDate"
                  value={startDate}
                  disableClock
                  format="   dd   /   MM     /   yyyy"
                  minDate={new Date()}
                />
                <div className="message-text error-message">
                  <p>{errorData.startDate}</p>
                </div>
              </CCol>
            </div>
            <div style={{ width: '39%' }} className="">
              <CFormLabel className="">Valid Till*</CFormLabel>
              <CCol>
                <DateTimePicker
                  className="shadow-effect w-100"
                  onChange={(value) => handleDateChange('endDate', value, setEndDate)}
                  name="endDate"
                  value={endDate}
                  disableClock
                  format="   dd    /    MM     /     yyyy"
                  minDate={startDate}
                />
                <div className="message-text error-message">
                  <p>{errorData.endDate}</p>
                </div>
              </CCol>
            </div>
          </div>
          {isGeoBlockAllowed && (
            <CRow>
              <CCol lg={4}>
                <CFormCheck
                  label="Enable Geo-Blocking"
                  value={geoBlocking}
                  checked={geoBlocking}
                  onChange={(e) => handleGeoBlocking(e)}
                />
              </CCol>
              <CCol lg={6}>
                {geoBlocking && (
                  <>
                    <CustomMultiSelect
                      selectedValue={geoBlockCountries}
                      optionsData={!isEmpty(countries) ? countries : []}
                      onChange={setGeoBlockCountries}
                      labelKey="name"
                      valueKey="iso2"
                    />
                    <div className="message-text error-message">
                      <p>{errorData.geoblock}</p>
                    </div>
                  </>
                )}
              </CCol>
            </CRow>
          )}
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton
          style={{
            color: '#3a3838',
            backgroundColor: 'white',
            marginRight: '2rem',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={handleClose}
        >
          Cancel
        </CButton>
        <CButton
          style={{
            color: 'white',
            backgroundColor: '#20211c',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          className="p text-white"
          onClick={handleCreate}
        >
          Save
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default SubscriptionCreateModal
